import React from "react"
import { batch } from "@preact/signals-react"

import { AppAntSwitch } from "@components"
import { includeProviders, mainProvider, mainSite, mainSiteProvider } from "@signals"


export default function AppCommonFiltersWebProviderToggleButton({ ...props }) {
	return <>
		<AppAntSwitch
			falseText="Web"
			trueText="Web & Provider"
			checked={includeProviders.value}
			onChange={newValue => includeProviders.value = newValue.target.checked}
			{...props}
		/>
		{includeProviders.value && <AppAntSwitch
			trueText="Main provider"
			falseText="Main site"
			checked={mainSiteProvider.value}
			onChange={newValue => batch(() => {
				mainSiteProvider.value = newValue.target.checked
				mainSite.value = ''
				mainProvider.value = ''
			})}
			{...props}
		/>}
	</>
}